import React, {useContext, useEffect, useState} from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import withAppContext from "tbk-components/src/hooks/withAppContext";
import { useHashAsState } from 'tbk-components/src/hooks/';

export interface ISearchBarProps extends IBaseElementProps {
	children?: any;
	backgroundColour?: 'white' | 'grey';
	hashAsState?: boolean;
	/**
	 * @noUI
	 */
	defaultState?: any;
	/**
	 * @noUI
	 */
	onSubmit?: ( state: any ) => void;
	/**
	 * @noUI
	 */
	includeTypeDropdown?: boolean;
	/**
	 * @noUI
	 */
	context?: { Api: { getLocationSearchBarAssets: () => Promise<{ action: string; types: any[] }> } };
}

/**
 * Search Bar
 */
const SearchBar: React.FC<ISearchBarProps> = withAppContext(({
	children,
	className,
	classNames = [],
	backgroundColour = 'grey',
	defaultState,
	hashAsState = false,
	onSubmit,
	includeTypeDropdown = true,
	context,
}) => {
	const { Api } = useContext( context );
	const [ assets, setAssets ] = useState<{action:string;types:any[]}>( null );
	const [ initialState, , updateHashState ] = useHashAsState({
		parameters: {
			search: 'string',
			type: 'int',
		},
		defaults: {
		},
	});
	const [ state, setState ] = useState( (hashAsState ? initialState : ( defaultState || {} ) ) as { search?: string; type?: number; } );
	const updateState = newState => {
		setState({
			...state,
			...newState,
		});
		if ( hashAsState ) {
			updateHashState( newState );
		}
	}
	useEffect( () => {
		if ( ! includeTypeDropdown && onSubmit ) {
			return;
		}
		Api.getLocationSearchBarAssets().then( setAssets );
	}, [includeTypeDropdown,onSubmit]);

	const onSubmitSearch = () => {
		const search = state.search || '';
		const type = state.type || '';
		if ( onSubmit ) {
			onSubmit({search,type});
		} else {
			window.location.href = `${assets.action}#!search=${encodeURIComponent(search)}&type=${type}`;
		}
	}
	const maybeSubmitSearch = e => {
		if ( e.which === 13 ) {
			onSubmitSearch();
		}
	}

	return <div className={className ||
		cn(
			'search-bar', ...classNames,
			!includeTypeDropdown && 'search-bar--no-dropdown',
			)
		}>
		<div className={`input-group input-background-${backgroundColour}`}>
			<div className="row">
				<div className="col-md">
					<div className="form-floating form-floating__left">
						<input
							type="text"
							className="form-control"
							id="floatingInputGrid"
							placeholder="Enter Postal Code or City"
							value={state.search}
							onChange={e => updateState({search:e.target.value})}
							onKeyPress={maybeSubmitSearch}
						/>
						<label
							className="floating-label"
							htmlFor="floatingInputGrid"
						>
							Location
						</label>
					</div>
				</div>
				{ includeTypeDropdown && (
				<div className="col-md">
					<div className="form-floating form-floating__right">
						<select
							className="form-select"
							id="floatingSelectGrid"
							aria-label="Select a Category"
							value={state.type}
							onChange={e => updateState({type:e.target.value})}
							onKeyPress={maybeSubmitSearch}
						>
							<option value="">Search by Type</option>
							{ Object.values( assets?.types || [] ).map( type => <option key={type.value} value={type.value}>{type.label}</option>) }
						</select>
						<label
							className="floating-label"
							htmlFor="floatingSelectGrid"
						>
							Looking for
						</label>
					</div>
				</div>
				)}
			</div>
			<button className="btn btn-primary" onClick={onSubmitSearch}>
				<i className="icon-search"></i>
				<span className="search-text">Search</span>
			</button>
		</div>
	</div>
});

export default SearchBar;
